import React from "react";

import Dashboard from "./Controllers/Dashboard/Dashboard";
import RoutingCms from "./Plugins/RoutingCms";
import Profile from "./Layout/Profile";
import Notifications from "./Controllers/Dashboard/Notifications";

class Routes {

    constructor() {
        this.routes=[
            {
                key: "dashboard",
                parentKey: "",
                breadcrumb: "ناحیه کاربری ",
                path: "/membership",
                main: () =><Dashboard />,
                exact: true
            },
            {
                key: "profile",
                parentKey: "dashboard",
                breadcrumb: "پروفایل",
                path: "/membership/profile",
                main: () =><Profile />,
                exact: true
            },
            {
                key: "message",
                parentKey: "dashboard",
                breadcrumb: "اطلاعیه ها",
                path: "/membership/message",
                main: () =><Notifications />,
                exact: true
            },
        ];
        let rc1=new RoutingCms();
        this.routes = this.routes.concat(rc1.get());
    }

    get(){
        return this.routes;
    }
}

export default Routes;
